export const validateEIN = (value: string) => {
  return /^\d{2}-\d{7}$/.test(value) || 'EIN must be 9 digits in format XX-XXXXXXX';
};
